import React from 'react';

export function Header() {
return(
    <nav className="navbar navbar-light bg-primary">
  <div className="container-fluid">
    <div className="h3 text-center text-light w-100">Grocery App</div>
  </div>
</nav>
);
}